export const purposeData = [
  {
    id: 1,
    uz: {
      title: "Maqsadimiz",
      descr:
        "Maqsadimiz yuqori malakali bakalavriat talabalarini kunduzgi, sirtqi va kechki taʼlim shakllarda, shuningdek, ikkinchi mutaxassislik bo‘yicha o‘zbek, rus va ingliz tillarida tayyorlashdan iborat. ",
    },
    ru: {
      title: "Взаимодействие с молодежью",
      descr:
        "Этот веб-сайт был создан школьниками для сбора полученных ими знаний и представления их на веб-сайте, чтобы предоставить им содержательный способ провести свободное время",
    },
    en: {
      title: "Youth Engagement",
      descr:
        "This website was created by school students to collect the knowledge they have acquired and present it on the website to provide them with a meaningful way to spend their free time.",
    },
  },
  {
    id: 2,
    uz: {
      title: "Bizning missiyamiz",
      descr:
        "Universitet logotipida bitilgan 'Renessans universiteti - Innovatsiya, Sifat, Istiqbol' shiori asosiy missiyamiz hisoblanadi. Xususan, innovatsion yondashuvlar asosida sifatli ta'limni yo'lga qo'yish orqali yorqin istiqbol uchun umidli kadrlarni yetishtirib chiqarish oldinga qo'yilgan ishlardan biridir.",
    },
    ru: {
      title: "Работа в команде",
      descr:
        "Обучение школьников командной работе и обучение их работе с коллегами по будущей профессии",
    },
    en: {
      title: "Teamwork",
      descr:
        "Teaching school students teamwork and teaching them to work with their colleagues in their future professions",
    },
  },
  {
    id: 3,

    uz: {
      title: "Zamoniy kasblarga jalb qilish",
      descr:
        "Yoshlarni zamonaviy kasblarga yo'naltirish va ularga platformamizdagi videodarsliklar orqali yordam berish",
    },
    ru: {
      title: "Тяга к современным профессиям",
      descr:
        "Направлять молодых людей к современной карьере и помогать им с помощью видеоуроков на нашей платформе",
    },
    en: {
      title: "Attraction to modern professions",
      descr:
        "Directing young people to modern careers and helping them through video tutorials on our platform",
    },
  },
  {
    id: 4,
    uz: {
      title: "Kitobxonlik sari chorlash",
      descr:
        "Yosh talabalarni bo'sh vaqtlarida online kitoblar bilan ta'minlab",
    },
    ru: {
      title: "Призыв к чтению",
      descr: "Предоставление юным читателям онлайн-книг в свободное время",
    },
    en: {
      title: "Call to reading",
      descr: "Providing young readers with online books in their spare time",
    },
  },
  {
    id: 5,
    uz: {
      title: "Universitetni rivojlantirish",
      descr:
        "Universitetimizni boshqalardan ajrlanib turishi maqsadida, alohida ta'lim bo'limini platformasini yaratish g'oyasini ilgari surish",
    },
    ru: {
      title: "Развитие Алмазарского района",
      descr:
        "Продвижение идеи создания отдельной платформы отдела образования, чтобы выделить наш район среди других округов",
    },
    en: {
      title: "Development of Almazor district",
      descr:
        "Promoting the idea of creating a separate education department platform in order to make our district stand out from other districts,",
    },
  },
  {
    id: 6,
    uz: {
      title: "Tajriba orttirish",
      descr:
        "Platformamizni yaratgan talabalrga o'zlarini tajribalarini orttirishga imkoniyat yaratgan holda, portfolio lari uchun katta bir imkoniyatni yaratib berish",
    },
    ru: {
      title: "Набираюсь опыта",
      descr:
        "Создать прекрасную возможность для портфолио студентов, создавших нашу платформу, и одновременно дать им возможность получить опыт",
    },
    en: {
      title: "Gaining experience",
      descr:
        "To create a great opportunity for the portfolios of the students who created our platform, while giving them the opportunity to gain experience.",
    },
  },
];
